import React, { useState } from "react";
import query from "../../Assets/svg/query icon.svg";
import Button from "../modules/Button";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function TopQuery(props) {
  const [logged, isLogged] = useState(true);
  const navigate = useNavigate();
  const registeredData = useSelector((state) => state.register.registeredData);
  const giveEmail = () => {
    let list = [];
    return (
      <div>
        <li>
          <>
            <span>mbascholarship@idfcfirstbank.com</span>
            for MBA scholarship related queries.
          </>
        </li>
        <li>
          <>
            <span>engscholarship@idfcfirstbank.com</span>
            for Engineering scholarship related queries.
          </>
        </li>
      </div>
    );
  };
  const raiseField = () => {
    let url = GetBaseUrl(window.location.href);
    navigate("/application/help/raise-queries");
    // window.location.replace(url + "/application/help/raise-queries");
  };
  const viewField = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/help/view-queries");
    navigate("/application/help/view-queries");
  };
  return (
    <div className="query-div">
      <div className="query-icon">
        <img src={query} alt="query" />
      </div>
      {props.loggedIn ? (
        <div className="query-msg ">
          In case you have any question,
          <br />
          please raise a query here
          <div onClick={viewField} className="upload-top-text">
            View Queries
          </div>
        </div>
      ) : (
        <div
          className={`query-msg  ${
            !props.loggedIn ? "not-logged" : ""
          }`}
        >
          If you have any questions, please write to us at:
          {giveEmail()}
          {/* <span>mbascholarship@idfcfirstbank.com</span>
          for MBA scholarship related queries.
          <span>engscholarship@idfcfirstbank.com</span>
          for Engineering scholarship related queries. */}
        </div>
      )}
      {props.loggedIn && (
        <Button
          type={"contained"}
          onClickHandler={raiseField}
          value={"Raise a Query"}
        />
      )}
    </div>
  );
}

export default TopQuery;
